export const SET_RAFFLE = 'RAFFLE/SET_RAFFLE'
export const SET_RAFFLES = 'RAFFLE/SET_RAFFLES'
